import CollectionName from "%/dynamic-component-editor/standard-components/base-collection-card/CollectionName.vue";
import CollectionDescription from "%/dynamic-component-editor/standard-components/base-collection-card/CollectionDescription.vue";
import CollectionCoverImage from "%/dynamic-component-editor/standard-components/base-collection-card/CollectionCoverImage.vue";
import CollectionItemCount from "%/dynamic-component-editor/standard-components/base-collection-card/CollectionItemCount.vue";
import CollectionCreated from "%/dynamic-component-editor/standard-components/base-collection-card/CollectionCreated.vue";
import CollectionUpdated from "%/dynamic-component-editor/standard-components/base-collection-card/CollectionUpdated.vue";
import EditCollectionButton from "%/dynamic-component-editor/standard-components/base-collection-card/EditCollectionButton.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyCollection extends LegacyEntity {
  get elements() {
    return {
      CollectionName,
      CollectionDescription,
      CollectionCoverImage,
      CollectionItemCount,
      CollectionCreated,
      CollectionUpdated,
      EditCollectionButton,
    };
  }
}
